import { memo } from 'react';
import { ProjectPicker as CatalogProjectPicker } from '@/features/catalog/ProjectPicker';
import { TagPicker as CatalogTagPicker } from '@/features/catalog/TagPicker';

// The catalog's pickers, memoized for the tracker, where many are on screen (one pair per entry,
// one in the timer bar): they skip re-rendering while their props are unchanged, so pass stable
// values (memoized `value` objects) and stable callbacks (useStableCallback).
export const ProjectPicker = memo(CatalogProjectPicker);
export const TagPicker = memo(CatalogTagPicker);
